import { useEffect, useRef, useState } from "react";

// Drop the sticky order-summary shadow once the bar rests inline at the very
// bottom of the page: pair the returned ref with a 0-height sentinel placed
// just below the sticky <aside>, so it only intersects the viewport when the
// bar is no longer floating.
export default function useStickySummaryShadow(deps: React.DependencyList = []) {
  const stickySentinelRef = useRef<HTMLDivElement | null>(null);
  const [summaryIsStuck, setSummaryIsStuck] = useState(true);

  useEffect(() => {
    const sentinel = stickySentinelRef.current;
    if (!sentinel || typeof IntersectionObserver === "undefined") {
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setSummaryIsStuck(!entry.isIntersecting), {
      threshold: 0,
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { stickySentinelRef, summaryIsStuck };
}
